import { render, staticRenderFns } from "./Toolbar.vue?vue&type=template&id=12f426f4&scoped=true&"
import script from "./Toolbar.vue?vue&type=script&lang=js&"
export * from "./Toolbar.vue?vue&type=script&lang=js&"
import style0 from "../../assets/flow-design.css?vue&type=style&index=0&id=12f426f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f426f4",
  null
  
)

export default component.exports